import { baseUrl } from '../../vue.config.js'
import moment from 'moment'
import Vue from 'vue'

window.toTotalTime = function (time, type = 'minutes') {
  var dur = moment.duration(time, type)
  var hours = Math.floor(dur.asHours())
  var mins = Math.floor(dur.asMinutes()) - hours * 60
  // var sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60
  return (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins)
}

window.getCookie = function (name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  if (match) return !match[2] || match[2] === 'undefined' ? '' : match[2]
}

window.createCookie = function (name, value, days) {
  var date, expires
  if (Number(days)) {
    date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toGMTString()
  } else if (!days.length) {
    expires = ''
  }
  let path = baseUrl || baseUrl !== 'undefined' ? baseUrl : '/'
  document.cookie = name + '=' + value + expires + '; path=' + path
}

window.capitalize = function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

let vueConfig = {
  install (Vue, options) {
    Vue.loadSelect = function (data, label, value, newProps) {
      return loadSelect(data, label, value, newProps)
    }
    Vue.prototype.$loadSelect = function (data, label, value, newProps) {
      return loadSelect(data, label, value, newProps)
    }

    Vue.toURLSearchParams = function (object) {
      return toURLSearchParams(object)
    }
    Vue.prototype.$toURLSearchParams = function (object) {
      return toURLSearchParams(object)
    }

    Vue.findLabel = function (data, id, label, value) {
      return findLabel(data, id, label, value)
    }
    Vue.prototype.$findLabel = function (data, id, label, value) {
      return findLabel(data, id, label, value)
    }

    // #################################
    // ##         FUNCTIONS           ##
    // #################################
    function findLabel (data, id, label = 'label', value = 'value', rightCondition, right) {
      if (!data) return id
      let result = data.find(x => x[value] === id)
      return result ? result[label] : id
    }

    function loadSelect (data, label = 'Nombre', value = 'Codigo', newProps = null) {
      let dataMaped = []
      data.map(item => {
        let _value = null
        let combinedValue = ''
        if (Array.isArray(value)) {
          value.forEach(key => {
            combinedValue += toString2(item[key]) + '/'
          })
          _value = combinedValue.slice(0, -1)
          //
        } else _value = item[value]

        let _label = null
        if (Array.isArray(label)) {
          let combinedLabel = ''
          label.forEach((key, index, array) => {
            if (index === array.length - 1) {
              combinedLabel += '(' + toString2(item[key]) + ')'
            } else {
              combinedLabel += toString2(item[key]) + ' '
            }
          })
          _label = combinedLabel
          //
        } else {
          _label = toString2(item[label])
        }

        let object = {
          label: toString2(_label),
          value: toString2(_value)
        }

        if (newProps && (typeof newProps === 'object' || newProps instanceof Object)) {
          if (newProps.checkTrue && newProps.propsTrue && item[newProps.checkTrue]) {
            newProps.propsTrue.forEach((val, index) => {
              object = Object.assign({}, val, object)
            })
          }
          if (newProps.checkFalse && newProps.propsFalse && !item[newProps.checkFalse]) {
            newProps.propsFalse.forEach((val, index) => {
              object = Object.assign({}, val, object)
            })
          }

          if (newProps.props) {
            newProps.props.forEach((val, index) => {
              object = Object.assign({}, { [val]: item[val] }, object)
            })
          }
        }
        dataMaped.push(object)
        // obj.newProp = obj.oldProp
        // delete obj.oldProp
      })

      dataMaped.sort((a, b) => {
        var nameA = a['label'].toLowerCase()
        var nameB = b['label'].toLowerCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0 // default return value (no sorting)
      })
      return dataMaped
    }

    function toURLSearchParams (object) {
      const params = new URLSearchParams()
      Object.keys(object).forEach(key => {
        if (typeof object[key] === 'object') {
          params.append(key, JSON.stringify(toString2(object[key])))
        } else params.append(key, toString2(object[key]))
      })
      return params
    }

    function toString2 (string) {
      return typeof string === 'string' || string instanceof String
        ? string.toString().trim()
        : string
    }
  }
}

Vue.use(vueConfig)
